import React from 'react';
import { CTAButton } from './CTAButton';
import { Star, Shield, Zap } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-8 px-4 sm:px-6 bg-brand-rose text-white border-t-4 border-brand-gold text-center" data-id="element-46" data-mp="3udoz2oyozioy">
      <p className="text-xs font-button font-bold text-brand-gold uppercase tracking-widest mb-1.5" data-id="element-47" data-mp="c83ori435i4h">
        ONE LAST CHANCE
      </p>

      <p className="text-sm sm:text-base font-medium mb-4 leading-tight max-w-2xl mx-auto" data-id="element-48" data-mp="m4yilnpeyucf">
        Your students deserve the best version of you — not an exhausted one.
        <br data-id="element-49" data-mp="h3rdjweno99g" />
        <br data-id="element-50" data-mp="h4135ivsgeem" />
        Stop spending your Sundays planning from scratch. Stop second-guessing
        your class structure mid-session. Stop letting creative burnout steal
        your passion for dance.
        <br data-id="element-51" data-mp="qy189kr2ljnc" />
        <br data-id="element-52" data-mp="14v6ilwxth4oe" />
        <span className="font-bold" data-id="element-53" data-mp="14uwp3zdkcfdy">
          Take back control of your teaching career with the professional tools
          you deserve.
        </span>
      </p>

      <div className="bg-white/10 border border-white/20 rounded-lg p-3 mb-4 shadow-md max-w-sm mx-auto" data-id="element-54" data-mp="zuijsp3cjjjm">
        <p className="text-xs sm:text-sm font-bold mb-0.5 uppercase tracking-wide" data-id="element-55" data-mp="2h3rgah3b7de6">
          Pack 6-in-1: Dance Ready™ + 5 Luxury Bonuses
        </p>
        <p className="text-base line-through opacity-70 mb-0.5" data-id="element-56" data-mp="2m21d0w4omm1w">$97 USD</p>
        <p className="text-3xl font-heading font-bold text-brand-gold leading-none" data-id="element-57" data-mp="2r278kne2osp9">
          Only: $27 USD
        </p>
      </div>

      <a href="https://danceready.impultienda.ar/checkout" className="block cursor-pointer mb-4" data-id="element-58" data-mp="2v2zh1ef4etkh">
        <img src="https://cdn.magicpatterns.com/uploads/vNhitVHkq5bJ6yeknhzbRq/ChatGPT-Image-14-jun-2026_-10_23_58-p.m..webp" alt="Dance Ready 6-in-1 Box Set" className="w-full max-w-[180px] mx-auto object-contain drop-shadow-xl" data-id="element-59" data-mp="300iyen747mgn" />
      </a>

      <div className="mb-3" data-id="element-60" data-mp="3et2syzg78lmh">
        <CTAButton href="https://danceready.impultienda.ar/checkout" className="!bg-brand-gold !text-brand-taupe border-none shadow-[0_4px_14px_0_rgba(212,175,55,0.39)] hover:shadow-[0_6px_20px_rgba(212,175,55,0.23)] hover:!bg-brand-gold/90" data-id="element-61" data-mp="3it38yoiy54vn">
          🚀 YES, I WANT MY DANCE READY™ PACK
        </CTAButton>
      </div>

      <div className="flex flex-col sm:flex-row justify-center items-center gap-1 sm:gap-4 text-[10px] sm:text-xs font-bold opacity-90" data-id="element-62" data-mp="1shgkfbqesn3b">
        <div className="flex items-center gap-1" data-id="element-63" data-mp="1no3w72pn6ib3">
          <Zap className="w-3.5 h-3.5 text-brand-gold" data-id="element-64" data-mp="22drz28dh1p0x" />
          <span data-id="element-65" data-mp="1xfqfzng1pppg">Immediate Access — Delivered by Email</span>
        </div>
        <div className="flex items-center gap-1" data-id="element-66" data-mp="1xfi3vxrqyofb">
          <Star className="w-3.5 h-3.5 fill-brand-gold text-brand-gold" data-id="element-67" data-mp="2bg178rl9p6b5" />
          <span data-id="element-68" data-mp="27dxv00qrxxot">4.9/5 — Verified Professional Reviews</span>
        </div>
        <div className="flex items-center gap-1" data-id="element-69" data-mp="27epcy8rg7wwm">
          <Shield className="w-3.5 h-3.5 text-brand-gold" data-id="element-70" data-mp="h0ymf775ycek" />
          <span data-id="element-71" data-mp="h3kvxcdm71zf">7-Day Guarantee — Zero Risk</span>
        </div>
      </div>
    </section>;
}